import './index.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-phone-number-input/style.css'
import { Suspense } from 'react'
import { ApolloProvider } from '@apollo/client/react'
import ReactDOM from 'react-dom/client'
import { ToastContainer } from 'react-toastify'
import client from 'src/apollo/client'
import LoadingPage from './pages/loading'
import { RouterProviderWithRole } from './routes'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ApolloProvider client={client}>
    <Suspense fallback={<LoadingPage />}>
      <RouterProviderWithRole />
    </Suspense>
    <ToastContainer position="bottom-right" theme={'dark'} />
  </ApolloProvider>,
)
